import React, { useEffect } from "react";
import withIntl from "../../utils/withIntl";
import PhonelinkIcon from "@material-ui/icons/Phonelink";
import { createMuiTheme, FormControlLabel, Link, Paper, Switch, ThemeProvider } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import cloudStore, { cloudStoreEvents } from "../../store/CloudStore";
import {
  getBusinessUnitsPos,
  getMenusPos,
  getMplusEmployees,
  getMplusFinancialBranches,
  getMplusTerminals,
  getPaymentMethodsPos,
  getUntillSalesareas,
  getWaiters,
  updatePos,
  updateSetupPos,
} from "./PosApi";
import SearchForms from "../Forms/SearchForms";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import TextFieldForms from "../Forms/TextFieldForms";
import { getArticles } from "../../store/articles/ArticlesApi";
import articlesStore from "../../store/articles/ArticlesStore";
import Tag from "./Tag";
import PaymentIcon from "@material-ui/icons/Payment";
import PhonelinkSetupIcon from "@material-ui/icons/PhonelinkSetup";
import SelectForms from "../Forms/SelectForms";
import InputAdornment from "@material-ui/core/InputAdornment";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

const theme = createMuiTheme({
  palette: {
    error: {
      main: "#3f51b5",
    },
  },
});

const useStyles = makeStyles({
  createPosPaperContainer: { padding: 10, width: 700, margin: 20 },
  textFieldContainer: {
    display: "flex",
    margin: 10,
  },
  label: { width: "40%" },
  input: { width: "60%" },
  labelError: { color: theme.palette.error.main },
});

function PosForm(props) {
  const classes = useStyles();
  const [merchantable, setMerchantable] = React.useState(cloudStore.merchant.merchantable);
  const [articles, setArticles] = React.useState(articlesStore.articles);
  const allPosFields = {
    MPLUS: {
      api_url: {
        value: merchantable.api_url,
        type: "text",
      },
      api_port: {
        value: merchantable.api_port,
        type: "text",
      },
      api_ident: {
        value: merchantable.api_ident,
        type: "text",
        helperText: "Api username / ident",
      },
      api_secret: {
        value: merchantable.api_secret,
        type: "text",
      },
      locale: {
        value: merchantable.locale,
        validation: "[a-zA-Z]{1,3}",
        type: "text",
        helperText: "Max. 3 chars. / only letters",
        required: true,
      },
      menu_sync_time: { value: merchantable.menu_sync_time, validation: null, type: "number" },
      sync_articlegroups: { value: merchantable.sync_articlegroups, validation: null, type: "boolean" },
      // use_queue: { value: merchantable.use_queue, validation: null, type: "boolean" },

      terminal: {
        value: merchantable.terminal,
        validation: null,
        type: "search",
        getResults: () =>
          new Promise((resolve) => {
            getMplusTerminals(merchantable.id)
              .then((res) => {
                resolve(res);
              })
              .catch(() => {});
          }),
      },
      financial_branch_number: {
        value: merchantable.financial_branch_number,
        validation: null,
        type: "search",
        getResults: () =>
          new Promise((resolve) => {
            getMplusFinancialBranches(merchantable.id)
              .then((res) => {
                resolve(res);
              })
              .catch(() => {});
          }),
      },
      employee: {
        value: merchantable.employee,
        validation: null,
        type: "search",
        getResults: () =>
          new Promise((resolve) => {
            getMplusEmployees(merchantable.id)
              .then((res) => {
                resolve(res);
              })
              .catch(() => {});
          }),
      },
    },

    UNTILL: {
      name: {
        value: merchantable.name,
        type: "text",
      },
      host: {
        value: merchantable.host,
        type: "text",
        helperText: "e.g. http://89.99.99.99",
      },
      username: {
        value: merchantable.username,
        type: "text",
      },
      password: {
        value: merchantable.password,
        type: "text",
      },
      port: {
        value: merchantable.port,
        type: "text",
        helperText: "e.g. 3063",
      },
      pathsuffix: {
        value: merchantable.pathsuffitx,
        type: "text",
        helperText: "/wsdl/ITPAPIPOS",
      },
      soap_url: {
        value: merchantable.soap_url,
        type: "text",
        helperText: "/soap/ITPAPIPOS",
      },
      locale: {
        value: merchantable.locale,
        validation: "[a-zA-Z]{1,3}",
        type: "text",
        helperText: "Max. 3 chars. / only letters",
        required: true,
      },
      last_menu_sync: { value: merchantable.last_menu_sync, validation: null, type: "date" },
      seconds_menu_sync: { value: merchantable.seconds_menu_sync, validation: null, type: "number" },

      pillar_use_tableparts: { value: merchantable.pillar_use_tableparts, validation: null, type: "boolean" },

      ta_use_tableparts: { value: merchantable.ta_use_tableparts, validation: null, type: "boolean" },
      ta_use_table_id: { value: merchantable.ta_use_table_id, validation: null, type: "boolean" },
      covers: { value: merchantable.covers, type: "text", helperText: "Default number of covers" },
      plu_article_message: {
        value: merchantable.plu_article_message,
        validation: null,
        type: "searchArticles",
      },
      sync_articlegroups: { value: merchantable.sync_articlegroups, validation: null, type: "boolean" },

      // payment_methods: {
      //   value: merchantable.payment_methods,
      //   type: "text"
      // },
      // extras: {
      //   value: merchantable.extras,
      //   type: "text"
      // },

      // use_queue: { value: merchantable.use_queue, validation: null, type: "boolean" },

      salesarea_id: {
        value: merchantable.salesarea_id,
        validation: null,
        type: "search",
        getResults: () =>
          new Promise((resolve) => {
            getUntillSalesareas(merchantable.id)
              .then((res) => {
                resolve(res);
              })
              .catch(() => {});
          }),
      },
    },

    IKENTOO: {
      email: {
        value: merchantable.email,
        type: "email",
        helperText: "input must be email",
        validation: null,
        required: true,
      },
      attach_email_to_customer: {
        value: merchantable.attach_email_to_customer,
        type: "boolean",
      },
      locale: {
        value: merchantable.locale,
        validation: "[a-zA-Z]{1,3}",
        type: "text",
        helperText: "Max. 3 chars. / only letters",
        required: true,
      },
      business_location_id: {
        value: merchantable.business_location_id,
        validation: null,
        type: "search",
        getResults: () =>
          new Promise((resolve) => {
            getBusinessUnitsPos(merchantable.id)
              .then((res) => {
                resolve(res);
              })
              .catch(() => {});
          }),
      },
      payment_article: {
        value: { plu: merchantable.payment_article?.plu },
        validation: null,
        type: "searchArticles",
      },
      delivery_article: {
        value: { plu: merchantable.delivery_article?.plu },
        validation: null,
        type: "searchArticles",
      },

      info: {
        value: { remark_plu: merchantable.info?.remark_plu },
        validation: null,
        type: "searchArticles",
      },
      menus: {
        value: merchantable.menus != null ? merchantable.menus : [],
        validation: null,
        type: "searchMenu",
        getResults: () =>
          new Promise((resolve) => {
            getMenusPos(props.posType.toLowerCase(), merchantable.id)
              .then((res) => {
                resolve(res);
              })
              .catch(() => {});
          }),
      },
      pillar_receipt_on_table: { value: merchantable.pillar_receipt_on_table, validation: null, type: "boolean" },
      production: { value: merchantable.production, validation: null, type: "boolean" },
      sp_account_profile_code: {
        value: merchantable.sp_account_profile_code,
        validation: null,
        type: "text",
      },
      pillar_account_profile_code: {
        value: merchantable.pillar_account_profile_code,
        validation: null,
        type: "text",
      },
      takeaway_account_profile_code: {
        value: merchantable.takeaway_account_profile_code,
        validation: null,
        type: "text",
      },
      delivery_account_profile_code: {
        value: merchantable.delivery_account_profile_code,
        validation: null,
        type: "text",
      },
      menu_sync_time: { value: merchantable.menu_sync_time, validation: null, type: "number" },
      sync_articlegroups: { value: merchantable.sync_articlegroups, validation: null, type: "boolean" },
      use_queue: { value: merchantable.use_queue, validation: null, type: "boolean" },
      use_courses: { value: merchantable.use_courses, validation: null, type: "boolean" },
      starting_course_number: { value: merchantable.starting_course_number, validation: null, type: "number" },
      payment_methods: {
        value: merchantable.payment_methods,
        validation: null,
        type: "searchPayment",
        getResults: () =>
          new Promise((resolve) => {
            getPaymentMethodsPos(props.posType.toLowerCase(), merchantable.id)
              .then((res) => {
                resolve(res);
              })
              .catch(() => {});
          }),
      },
    },
    GASTROFIX: {
      operator_id: { value: merchantable.operator_id, type: "number" },
      ext_gastrofix_id: {
        value: merchantable.ext_gastrofix_id,
        helperText: "",
        validation: null,
        type: "number",
        required: true,
      },
      article_api_version: {
        value: merchantable.article_api_version,
        validation: null,
        type: "number",
        required: true,
      },
      token: {
        value: merchantable.token,
        validation: "[A-Za-z0-9]{1,40}",
        type: "text",
        helperText: "max. 40 chars.",
        required: true,
      },
      locale: {
        value: merchantable.locale,
        validation: "[a-zA-Z]{1,3}",
        type: "text",
        helperText: "Max. 3 chars. / only letters",
        required: true,
      },
      sync_articlegroups: { value: merchantable.sync_articlegroups, validation: null, type: "boolean" },
      menu_sync_time: { value: merchantable.menu_sync_time, validation: null, type: "number" },
      payment_methods: {
        value: typeof merchantable.info === "string" ? JSON.parse(merchantable.info).payment_methods : {},
        validation: null,
        type: "searchPayment",
        getResults: () =>
          new Promise((resolve) => {
            getPaymentMethodsPos(props.posType.toLowerCase(), merchantable.id)
              .then((res) => {
                resolve(res);
              })
              .catch(() => {});
          }),
      },
      waiter_id: {
        value: merchantable.waiter_id,
        type: "search",
        validation: null,
        getResults: () =>
          new Promise((resolve) => {
            getWaiters(props.posType.toLowerCase(), merchantable.id)
              .then((res) => {
                resolve(res);
              })
              .catch(() => {});
          }),
      },
      payment_plu: {
        value: typeof merchantable.info === "string" ? JSON.parse(merchantable.info).payment_plu : null,
        validation: null,
        type: "searchArticlesGastrofix",
      },
      delivery_plu: {
        value: typeof merchantable.info === "string" ? JSON.parse(merchantable.info).delivery_plu : null,
        type: "searchArticlesGastrofix",
      },
    },
    TAURUS: {
      name: { value: "", required: true },
      host: {
        value: merchantable.host,
        placeholder: "http://185.83.15.64",
        validation: null,
        type: "text",
        required: true,
      },
      port: { value: merchantable.port, validation: null, placeholder: 80, type: "number", required: true },
      pathsuffix: { value: merchantable.pathsuffix, validation: null, type: "text", required: true },
      seconds_menu_sync: { value: merchantable.seconds_menu_sync, validation: null, type: "number", required: true },
      receipt_sync_time: {
        value: merchantable.receipt_sync_time,
        validation: null,
        placeholder: 80,
        type: "number",
        required: true,
      },
      timeout: {
        value: merchantable.timeout,
        validation: null,
        placeholder: 10,
        type: "number",
        required: true,
      },
      advanced_tables: { value: merchantable.advanced_tables, validation: null, type: "boolean", required: true },
      sync_images: { value: merchantable.sync_images, validation: null, type: "boolean", required: true },
      betaalwijze: { value: merchantable.betaalwijze, validation: null, type: "number", required: true },
    },
    LIGHTSPEED: {
      email: {
        value: merchantable.email,
        helperText: "input must be email",
        validation: null,
        type: "email",
        required: true,
      },
      locale: {
        value: merchantable.locale,
        validation: "[a-zA-Z]{1,3}",
        type: "text",
        helperText: "Max. 3 chars. / only letters",
        required: true,
      },
      payment_methods: {
        value: merchantable.payment_methods,
        validation: null,
        type: "searchPayment",
      },
      payment_article: {
        value: { plu: merchantable.payment_article?.plu },
        validation: null,
        type: "searchArticles",
      },
      delivery_article: {
        value: { plu: merchantable.delivery_article?.plu },
        validation: null,
        type: "searchArticles",
      },
      pillar_receipt_on_table: { value: merchantable.pillar_receipt_on_table, validation: null, type: "boolean" },
      production: { value: merchantable.production, validation: null, type: "boolean" },
      ta_receipt_on_table: { value: merchantable.ta_receipt_on_table, validation: null, type: "boolean" },
      menu_sync_time: { value: merchantable.menu_sync_time, validation: null, type: "number" },
      setup: { value: { email: "", firstName: "", lastName: "", type: "" } },
      sp_receipt_customer_id: { value: merchantable.sp_receipt_customer_id, type: "customerId" },
      ta_receipt_customer_id: { value: merchantable.ta_receipt_customer_id, type: "customerId" },
      pillar_receipt_customer_id: { value: merchantable.pillar_receipt_customer_id, type: "customerId" },
    },
  };

  const [activePos, setActivePos] = React.useState(allPosFields[props.posType]);
  const switchFields = activePos ? Object.keys(activePos).filter((field) => activePos[field].type === "boolean") : [];
  const search = activePos ? Object.keys(activePos).filter((field) => activePos[field].type === "search") : [];
  const textFields = activePos
    ? Object.keys(activePos).filter(
        (field) =>
          activePos[field].type === "text" || activePos[field].type === "email" || activePos[field].type === "number"
      )
    : [];
  const searchArticles = activePos
    ? Object.keys(activePos).filter((field) => activePos[field].type === "searchArticles")
    : [];
  const searchArticlesGastrofix = activePos
    ? Object.keys(activePos).filter((field) => activePos[field].type === "searchArticlesGastrofix")
    : [];
  const customerIdFields = activePos
    ? Object.keys(activePos).filter((field) => activePos[field].type === "customerId")
    : [];

  let paymentMethodsMerchant = [];

  cloudStore.merchant.ta_merchants.map((merchant) => {
    if (merchant.payment_methods != null) {
      JSON.parse(merchant.payment_methods).forEach((paymentMethod) => {
        if (
          !paymentMethodsMerchant
            .map((uniqueMethod) => Object.keys(uniqueMethod)[0])
            .includes(Object.keys(paymentMethod)[0])
        ) {
          paymentMethodsMerchant.push(paymentMethod);
        }
      });
    }
  });

  cloudStore.merchant.sp_merchants.forEach((merchant) => {
    if (merchant.payment_methods != null) {
      merchant.payment_methods.forEach((paymentMethod) => {
        if (
          !paymentMethodsMerchant
            .map((uniqueMethod) => Object.keys(uniqueMethod)[0])
            .includes(Object.keys(paymentMethod)[0])
        ) {
          paymentMethodsMerchant.push(paymentMethod);
        }
      });
    }
  });

  useEffect(() => {
    if (cloudStore.merchant.id !== articlesStore.merchantId) {
      getArticles(cloudStore.merchant.id);
    }
  }, []);

  const [paymentMethodsGastrofix, setPaymentMethodsGastrofix] = React.useState(null);

  useEffect(() => {
    if (props.posType === "GASTROFIX" && activePos.operator_id.value != null) {
      (async () => {
        let paymentMethods = [];
        await getPaymentMethodsPos(props.posType.toLowerCase(), merchantable.id).then((res) => {
          if (res.length < 1) {
            paymentMethods = null;
          } else {
            paymentMethods = res;
          }
        });
        setPaymentMethodsGastrofix(paymentMethods);
      })();
    }
  }, []);

  const onChangeMerchant = () => {
    setMerchantable({ ...cloudStore.merchant.merchantable });
  };

  useEffect(() => {
    cloudStore.on(cloudStoreEvents.MERCHANT_UPDATED, onChangeMerchant);
    return () => cloudStore.removeListener(cloudStoreEvents.MERCHANT_UPDATED, onChangeMerchant);
  }, []);

  useEffect(() => {
    setActivePos(allPosFields[props.posType]);
  }, [merchantable]);

  const onChangeArticles = () => {
    setArticles({ ...articlesStore.articles });
  };

  useEffect(() => {
    articlesStore.on(articlesStore.events.ARTICLES_UPDATED, onChangeArticles);
    return () => cloudStore.removeListener(cloudStoreEvents.ARTICLES_UPDATED, onChangeArticles);
  }, []);

  const handleAddMenuId = (menu) => {
    let newValues = [...activePos["menus"].value];
    if (!newValues.find((menu2) => menu2.menuId === menu.id)) {
      newValues.push({ name: menu.name, menuId: menu.id });
    }
    let newActive = { ...activePos, menus: { ...activePos["menus"], value: newValues } };
    setActivePos(newActive);
  };

  const handleDeleteMenuId = (menuId) => {
    let newValues = [...activePos["menus"].value];
    let index = newValues.map((menu) => menu.menuId).indexOf(menuId);
    newValues.splice(index, 1);
    let newActive = { ...activePos, menus: { ...activePos["menus"], value: newValues } };
    setActivePos(newActive);
  };

  const handleEditTag = (menu, value) => {
    let newValues = [...activePos["menus"].value];
    let index = newValues.map((menu) => menu.menuId).indexOf(menu.menuId);
    if (value.length > 0) {
      newValues.splice(index, 1, { ...menu, menuTag: value });
    } else {
      newValues.splice(index, 1, { menuId: menu.menuId });
    }
    let newActive = { ...activePos, menus: { ...activePos["menus"], value: newValues } };
    setActivePos(newActive);
  };

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Paper classes={{ root: classes.createPosPaperContainer }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <PhonelinkIcon fontSize={"large"} />
            <Typography variant={"h6"} style={{ marginLeft: "8px" }}>
              {props.posType}
            </Typography>
          </div>
          {activePos && (props.posType === "LIGHTSPEED" || props.posType === "IKENTOO") && (
            <div style={{ display: "inlineBlock" }}>
              <Typography style={{ display: "inline" }}>
                {merchantable.access_token || merchantable.refresh_token
                  ? props.intl.formatMessage({ id: "you_are_logged_in" })
                  : props.intl.formatMessage({ id: "you_are_not_logged_in" })}
              </Typography>
              <Link
                style={{ margin: 5 }}
                target="_blank"
                href={`https://api.mynober.nl/${props.posType.toLowerCase()}/v1/auth/${merchantable.id}?email=${
                  merchantable.email
                }`}
              >
                click here
              </Link>
            </div>
          )}
          <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
          <form
            autoComplete={"off"}
            key={props.posType}
            onSubmit={(e) => {
              e.preventDefault();
              const idType = `${props.posType.toLowerCase()}MerchantId`;
              let newPos = {};
              newPos.info = {};
              Object.keys(activePos).forEach((key) => {
                if (
                  key === "payment_plu" ||
                  key === "delivery_plu" ||
                  (props.posType === "GASTROFIX" && key === "payment_methods")
                ) {
                  newPos.info[key] = activePos[key].value;
                } else {
                  newPos[key] = activePos[key].value;
                }
              });

              updatePos(newPos, props.posType, { [idType]: merchantable.id })
                .then((data) => {})
                .catch((err) => console.log(err));
            }}
          >
            {search.map((field) => {
              return (
                <SearchForms
                  valueVisibleAsLabel
                  noResultsText={"login for results"}
                  error={merchantable[field] !== activePos[field].value}
                  variant={"outlined"}
                  label={field}
                  value={activePos[field].value}
                  placeholder={!activePos[field].value && "select"}
                  getResults={activePos[field].getResults}
                  handleSelect={(option) => {
                    let newActive = { ...activePos };
                    newActive[field].value = option.id;
                    setActivePos(newActive);
                  }}
                />
              );
            })}
            {activePos.menus && (
              <>
                <SearchForms
                  noResultsText={"login for results"}
                  variant={"outlined"}
                  label={"menus"}
                  handleSelect={(option) => {
                    handleAddMenuId(option);
                  }}
                  getResults={activePos.menus.getResults}
                />
                <div style={{ display: "flex" }}>
                  <div style={{ width: "40%" }} />
                  <div style={{ width: "60%" }}>
                    {activePos.menus &&
                      activePos.menus.value?.map((menu) => {
                        const cloudStoreMenu = cloudStore.merchant.merchantable.menus?.find(
                          (menu2) => menu2.menuId === menu.menuId
                        );
                        return (
                          <Tag
                            error={menu.menuTag !== cloudStoreMenu?.menuTag}
                            name={menu.name}
                            tag={menu.menuTag}
                            onDelete={() => {
                              handleDeleteMenuId(menu.menuId);
                            }}
                            handleEditTag={(value) => handleEditTag(menu, value)}
                          />
                        );
                      })}
                  </div>
                </div>
              </>
            )}
            {activePos &&
              textFields.map((field, index) => {
                return (
                  <TextFieldForms
                    label={activePos[field].required ? field + "*" : field}
                    required={activePos[field].required}
                    key={field}
                    type={activePos[field].type}
                    helperTextLabel={activePos[field].helperText}
                    error={activePos[field].value !== cloudStore.merchant.merchantable[field]}
                    inputProps={{ pattern: activePos[field].validation }}
                    value={activePos[field].value}
                    onChange={(e) => {
                      let newActive = { ...activePos };
                      let newValue = e.target.value === "" ? null : e.target.value;
                      newActive[field].value = newValue;
                      setActivePos(newActive);
                    }}
                  />
                );
              })}
            {articles &&
              searchArticles.map((field) => {
                // console.log(activePos[field].value)
                // console.log(activePos);
                // console.log(
                //   activePos[field].value ? activePos[field].value[Object.keys(activePos[field].value)] : null
                // );
                // console.log(activePos[field].value[Object.keys(activePos[field].value)]);
                return (
                  <SearchForms
                    valueVisibleAsLabel
                    noResultsText={"no results"}
                    error={
                      merchantable[field]?.[Object.keys(activePos[field].value ?? {})] !==
                      activePos[field].value?.[Object.keys(activePos[field].value ?? {})]
                    }
                    variant={"outlined"}
                    label={field}
                    value={
                      activePos[field].value?.[Object.keys(activePos[field].value ?? {})]
                        ? Object.keys(activePos[field].value)[0] +
                          ": " +
                          activePos[field].value[Object.keys(activePos[field].value ?? {})]
                        : (typeof activePos[field].value != "object" ? activePos[field].value : null) ??
                          "select article"
                    }
                    handleSelect={(option) => {
                      let newActive = { ...activePos };
                      if (typeof newActive[field].value == "object") {
                        newActive[field].value = { [Object.keys(activePos[field].value)]: option.id };
                      } else {
                        newActive[field].value = option.id;
                      }
                      setActivePos(newActive);
                    }}
                    allResults={
                      articles
                        ? Object.keys(articles).map((key) => {
                            return {
                              id: articlesStore.articles[key].plu,
                              name: `${articlesStore.articles[key].name} - plu: ${articlesStore.articles[key].plu}`,
                            };
                          })
                        : [{ id: 0, name: "no results" }]
                    }
                  />
                );
              })}
            {articles &&
              searchArticlesGastrofix.map((field) => {
                return (
                  <SearchForms
                    valueVisibleAsLabel
                    noResultsText={"no results"}
                    error={
                      JSON.parse(merchantable.info)?.[field]
                        ? JSON.parse(merchantable.info)[field] !== activePos[field].value
                        : false
                    }
                    variant={"outlined"}
                    label={field}
                    value={activePos[field].value ? "plu: " + activePos[field].value : "select article"}
                    handleSelect={(option) => {
                      let newActive = { ...activePos };
                      newActive[field].value = option.id;
                      setActivePos(newActive);
                    }}
                    allResults={
                      articles
                        ? Object.keys(articles).map((key) => {
                            return {
                              id: articlesStore.articles[key].plu,
                              name: `${articlesStore.articles[key].name} - plu: ${articlesStore.articles[key].plu}`,
                            };
                          })
                        : [{ id: 0, name: "no results" }]
                    }
                  />
                );
              })}
            {activePos &&
              switchFields.map((field, index) => {
                return (
                  <FormControlLabel
                    control={
                      <Switch
                        checked={activePos[field].value == 1}
                        onChange={(e) => {
                          let newActive = { ...activePos };
                          if (activePos[field].value === 1) {
                            newActive[field].value = 0;
                          } else {
                            newActive[field].value = 1;
                          }
                          setActivePos(newActive);
                        }}
                        color="primary"
                      />
                    }
                    label={field}
                    classes={activePos[field].value !== merchantable[field] ? { label: classes.labelError } : null}
                  />
                );
              })}
            <div style={{ height: 50 }}>
              <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
              <Button type="submit" style={{ margin: 5, float: "right" }}>
                {props.intl.formatMessage({ id: "save_pos" })}
              </Button>
            </div>
          </form>
        </Paper>
      </div>
      {activePos.payment_methods && (
        <div>
          <Paper classes={{ root: classes.createPosPaperContainer }}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                const idType = `${props.posType.toLowerCase()}MerchantId`;
                let newPos = {};
                newPos.info = {};
                Object.keys(activePos).forEach((key) => {
                  if (
                    key === "payment_plu" ||
                    key === "delivery_plu" ||
                    (props.posType === "GASTROFIX" && key === "payment_methods")
                  ) {
                    newPos.info[key] = activePos[key].value;
                  } else {
                    newPos[key] = activePos[key].value;
                  }
                });

                updatePos(newPos, props.posType, { [idType]: merchantable.id })
                  .then((data) => {})
                  .catch((err) => console.log(err));
              }}
            >
              {activePos.payment_methods && (
                <>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <PaymentIcon fontSize={"large"} />
                    <Typography variant={"h6"} style={{ marginLeft: "8px" }}>
                      Payment methods
                    </Typography>
                  </div>
                </>
              )}
              {paymentMethodsMerchant.length === 0 && <Typography>No payment methods selected</Typography>}

              {activePos.payment_methods &&
                paymentMethodsMerchant.map((method) => {
                  if (props.posType === "GASTROFIX") {
                    let value = activePos.payment_methods.value[Object.keys(method)[0]] ?? null;
                    return (
                      <SearchForms
                        createOption={(searchValue) => ({
                          id: parseInt(searchValue),
                          name: searchValue,
                          description: searchValue,
                        })}
                        valueVisibleAsLabel
                        noResultsText={"login for results"}
                        error={
                          JSON.parse(merchantable.info)?.payment_methods[Object.keys(method)[0]] !==
                          activePos.payment_methods.value?.[Object.keys(method)[0]]
                        }
                        variant={"outlined"}
                        label={Object.keys(method)[0]}
                        getResults={() =>
                          new Promise((resolve) => {
                            getPaymentMethodsPos(props.posType.toLowerCase(), merchantable.id)
                              .then((res) => {
                                resolve(res);
                              })
                              .catch(() => {
                                resolve([]);
                              });
                          })
                        }
                        placeholder={"select POS payment method"}
                        value={
                          paymentMethodsGastrofix != null || method.description != null
                            ? paymentMethodsGastrofix.find(
                                (methodObject) =>
                                  methodObject.id === activePos.payment_methods.value?.[Object.keys(method)[0]]
                              )?.shortName
                            : value
                        }
                        handleSelect={(option) => {
                          let newActive = { ...activePos };
                          let newValue = {
                            ...newActive.payment_methods.value,
                            [Object.keys(method)[0]]: option.id,
                          };
                          if (option.id === "") {
                            delete newValue[Object.keys(method)[0]];
                          }
                          newActive.payment_methods.value = newValue;

                          setActivePos(newActive);
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <HighlightOffIcon
                                onClick={() => {
                                  let newActive = {
                                    ...activePos,
                                  };
                                  let newValues = { ...newActive.payment_methods.value };
                                  delete newValues[Object.keys(method)[0]];

                                  newActive["payment_methods"].value = newValues;
                                  setActivePos(newActive);
                                }}
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    );
                  } else {
                    return (
                      <SearchForms
                        key={activePos.payment_methods.value?.[Object.keys(method)[0]]?.name}
                        valueVisibleAsLabel
                        noResultsText={"login for results"}
                        error={
                          merchantable.payment_methods?.[Object.keys(method)[0]]?.paymentTypeId
                            ? merchantable.payment_methods?.[Object.keys(method)[0]].name !==
                              activePos.payment_methods.value?.[Object.keys(method)[0]]?.name
                            : merchantable.payment_methods?.[Object.keys(method)[0]]?.paymentMethodCode !==
                              activePos.payment_methods.value?.[Object.keys(method)[0]]?.paymentMethodCode
                        }
                        variant={"outlined"}
                        label={Object.keys(method)[0]}
                        getResults={() =>
                          new Promise((resolve) => {
                            getPaymentMethodsPos(props.posType.toLowerCase(), merchantable.id)
                              .then((res) => {
                                resolve(res);
                              })
                              .catch(() => {});
                          })
                        }
                        placeholder={"select POS payment method"}
                        value={activePos.payment_methods.value?.[Object.keys(method)[0]]?.name}
                        handleSelect={(option) => {
                          let newActive = {
                            ...activePos,
                          };
                          if (option.code) {
                            newActive.payment_methods.value = {
                              ...newActive.payment_methods.value,
                              [Object.keys(method)[0]]: { paymentMethodCode: option.code, name: option.name },
                            };
                          } else {
                            newActive.payment_methods.value = {
                              ...newActive.payment_methods.value,
                              [Object.keys(method)[0]]: {
                                paymentTypeId: option.id,
                                paymentTypeTypeId: option.typeId,
                                name: option.name,
                              },
                            };
                          }

                          setActivePos(newActive);
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <HighlightOffIcon
                                onClick={() => {
                                  let newActive = {
                                    ...activePos,
                                  };
                                  let newValues = { ...newActive.payment_methods.value };
                                  delete newValues[Object.keys(method)[0]];

                                  newActive["payment_methods"].value = newValues;
                                  setActivePos(newActive);
                                }}
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                    );
                  }
                })}
              <div style={{ height: 50 }}>
                <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
                <Button type="submit" style={{ margin: 5, float: "right" }}>
                  Save payment methods
                </Button>
              </div>
            </form>
          </Paper>
        </div>
      )}
      {props.posType === "LIGHTSPEED" && (
        <div>
          <Paper classes={{ root: classes.createPosPaperContainer }}>
            <form
              key={"lightspeed"}
              onSubmit={(e) => {
                e.preventDefault();
                updateSetupPos(activePos.setup.value, merchantable.id).then((data) => {});
              }}
            >
              <>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <PhonelinkSetupIcon fontSize={"large"} />
                  <Typography variant={"h6"} style={{ marginLeft: "8px" }}>
                    Customer Setup
                  </Typography>
                </div>
              </>
              {customerIdFields.map((field) => {
                if (activePos[field].value) {
                  return (
                    <TextFieldForms key={merchantable[field]} disabled label={field} value={activePos[field].value} />
                  );
                }
              })}
              <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
              <SelectForms
                variant={"outlined"}
                label={"setup type*"}
                helperTextLabel={"select to create new Customer Setup"}
                menuItems={[
                  { id: 10, name: "ta" },
                  { id: 20, name: "sp" },
                  { id: 30, name: "pillar" },
                ]}
                placeholder={"select setup type"}
                value={activePos.setup.value.type}
                handleSelect={(item) => {
                  let newActive = {
                    ...activePos,
                  };
                  newActive.setup.value = {
                    ...newActive.setup.value,
                    type: item,
                  };
                  setActivePos(newActive);
                }}
              />
              {activePos.setup &&
                Object.keys(activePos.setup.value).map((key) => {
                  if (key !== "type") {
                    return (
                      <TextFieldForms
                        value={activePos.setup.value[key]}
                        label={key + "*"}
                        helperTextLabel={key === "email" && "Input must be email"}
                        onChange={(e) => {
                          let newActive = { ...activePos };
                          newActive.setup.value[key] = e.target.value;
                          setActivePos(newActive);
                        }}
                      />
                    );
                  }
                })}
              <div style={{ height: 50 }}>
                <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
                <Button type="submit" style={{ margin: 5, float: "right" }}>
                  save customer setup
                </Button>
              </div>
            </form>
          </Paper>
        </div>
      )}
    </ThemeProvider>
  );
}

export default withIntl(PosForm);
